import { render, staticRenderFns } from "./goldHistory.vue?vue&type=template&id=2ac5ad2e&scoped=true"
import script from "./goldHistory.vue?vue&type=script&lang=js"
export * from "./goldHistory.vue?vue&type=script&lang=js"
import style0 from "./goldHistory.vue?vue&type=style&index=0&id=2ac5ad2e&prod&lang=scss&scoped=true"
import style1 from "./goldHistory.vue?vue&type=style&index=1&id=2ac5ad2e&prod&scoped=true&lang=css"
import style2 from "./goldHistory.vue?vue&type=style&index=2&id=2ac5ad2e&prod&lang=scss&scoped=true"
import style3 from "./goldHistory.vue?vue&type=style&index=3&id=2ac5ad2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5ad2e",
  null
  
)

export default component.exports